import { fetchAuthenticatedObjectUrl, resolveDownloadUrl } from './authenticatedDownload';

const cache = new Map<string, Promise<string>>();

export const getAuthenticatedImageObjectUrl = (downloadUrl: string): Promise<string> => {
  const key = resolveDownloadUrl(downloadUrl);
  let pending = cache.get(key);

  if (!pending) {
    pending = fetchAuthenticatedObjectUrl(downloadUrl).catch((err) => {
      cache.delete(key);
      throw err;
    });
    cache.set(key, pending);
  }

  return pending;
};
